import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router'
import { Loader2 } from 'lucide-react'
import Login from './pages/Login'
import PulseShell from './components/PulseShell'
import { PulseProtectedRoute } from './components/PulseProtectedRoute'

const Import = lazy(() => import('./pages/Import'))
const Enrichment = lazy(() => import('./pages/Enrichment'))
const MergeManager = lazy(() => import('./components/MergeManager'))
const Prospects = lazy(() => import('./pages/Prospects'))
const DonorProfile = lazy(() => import('./pages/DonorProfile'))
const Committees = lazy(() => import('./pages/Committees'))
const CommitteeDetails = lazy(() => import('./pages/CommitteeDetails'))
const Lists = lazy(() => import('./pages/Lists'))
const ListDetails = lazy(() => import('./pages/ListDetails'))
const SetupMfa = lazy(() => import('./pages/SetupMfa'))
const VerifyMfa = lazy(() => import('./pages/VerifyMfa'))

function RouteLoader() {
  return (
    <div className="min-h-screen bg-theme-bg flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-theme-cta" />
    </div>
  )
}

// --- Main App Component ---

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/mfa/setup" element={<Suspense fallback={<RouteLoader />}><SetupMfa /></Suspense>} />
        <Route path="/mfa/verify" element={<Suspense fallback={<RouteLoader />}><VerifyMfa /></Suspense>} />
        
        {/* Protected Area */}
        <Route path="/" element={
          <PulseProtectedRoute>
            <Suspense fallback={<RouteLoader />}>
              <PulseShell />
            </Suspense>
          </PulseProtectedRoute>
        }>
          <Route index element={<Navigate to="/prospects" replace />} />
          <Route path="import" element={<Suspense fallback={<RouteLoader />}><Import /></Suspense>} />
          <Route path="enrichment" element={<Suspense fallback={<RouteLoader />}><Enrichment /></Suspense>} />
          <Route path="reconcile" element={<Suspense fallback={<RouteLoader />}><MergeManager /></Suspense>} />
          <Route path="prospects" element={<Suspense fallback={<RouteLoader />}><Prospects /></Suspense>} />
          <Route path="lists" element={<Suspense fallback={<RouteLoader />}><Lists /></Suspense>} />
          <Route path="lists/:id" element={<Suspense fallback={<RouteLoader />}><ListDetails /></Suspense>} />
          <Route path="committees" element={<Suspense fallback={<RouteLoader />}><Committees /></Suspense>} />
          <Route path="committee/:id" element={<Suspense fallback={<RouteLoader />}><CommitteeDetails /></Suspense>} />
          <Route path="donor/:id" element={<Suspense fallback={<RouteLoader />}><DonorProfile /></Suspense>} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
